module.exports = __webpack_public_path__ + "static/day19-d3c81aaf8f34bcb6db945bff177388e3.png";